import latenize from '../filters/latenize';

class stringHelper {

    /**
     * Remove acentos de uma string
     * @param  {string} strAccents Uma string com acentos
     * @return {string}            Retorna uma string sem acentos
     */
    removeAccents(strAccents) {
        var strAccents = strAccents.split('');
        let strAccentsOut = new Array();
        let strAccentsLen = strAccents.length;
        let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        for (let y = 0; y < strAccentsLen; y++) {
            if (accents.indexOf(strAccents[y]) != -1)
                strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
            else
                strAccentsOut[y] = strAccents[y];
        }
        strAccentsOut = strAccentsOut.join('');
        return strAccentsOut;
    }

    leftTrim(str, char = '\\s') {
      const re = new RegExp(`^${char}+`);
      return str.replace(re,"");
    }
    
}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function validarCNPJ(cnpj) {

  cnpj = cnpj.replace(/[^\d]+/g,'');

  if(cnpj === '') return false;

  if (cnpj.length !== 14)
    return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999")
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0,tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
    return false;

  return true;

}

/**
 * Validar numeração CNJ de processos judiciais
 *
 * @param {String} numero
 * @returns {boolean}
 */
export function validateNumeroUnicoProcesso(numero) {
  const bcmod = (x, y) =>
  {
    // how many numbers to take at once? carefull not to exceed (int)
    const take = 5;
    let mod = '';

    do
    {
      let a = parseInt(mod + x.substr(0, take));
      x = x.substr(take);
      mod = a % y;
    }
    while (x.length);

    return mod;
  };

  // remove todos os pontos e traços
  const numeroProcesso = numero.replace(/[.-]/g, '')

  if (numeroProcesso.length < 14 || isNaN(numeroProcesso)) {
    return false;
  }

  const digitoVerificadorExtraido = parseInt(numeroProcesso.substr(-13, 2));

  const vara = numeroProcesso.substr(-4, 4);  // (4) vara originária do processo
  const tribunal = numeroProcesso.substr(-6, 2);  // (2) tribunal
  const ramo = numeroProcesso.substr(-7, 1);  // (1) ramo da justiça
  const anoInicio = numeroProcesso.substr(-11, 4);  // (4) ano de inicio do processo
  const size = numeroProcesso.length - 13;
  const numeroSequencial = numeroProcesso.substr(0, size).padStart(7, '0');  // (7) numero sequencial dado pela vara ou juizo de origem

  const digitoVerificadorCalculado = 98 - bcmod((numeroSequencial + anoInicio + ramo + tribunal + vara + '00'), '97');

  return digitoVerificadorExtraido === digitoVerificadorCalculado;
}

function escapeReg(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function regexParaHighlightTermoMonitorado(termoMonitoramento, variacoesMonitoramento) {
  const regexInicial = escapeReg(latenize(termoMonitoramento));
  if (Array.isArray(variacoesMonitoramento)) {
    return variacoesMonitoramento.reduce((variacoes, variacao) => {
      return `${variacoes}|${escapeReg(latenize(variacao.variacao))}`;
    }, regexInicial)
  }

  return regexInicial;
}

export function addHighlightConteudoAparicao(termo, variacoes, conteudo) {
  const conteudoSemAcentos = latenize(conteudo);
  let posicoesEncontradas = [];
  const pattern = new RegExp(`(?!<[^>]*?>)(${regexParaHighlightTermoMonitorado(termo, variacoes)})(?![^<]*?>)`, 'gi');

  let match = pattern.exec(conteudoSemAcentos);
  while (match) {
    posicoesEncontradas.push({
      index: match.index,
      lastIndex: pattern.lastIndex
    });
    match = pattern.exec(conteudoSemAcentos)
  }
  let conteudoComHighlight = conteudo;

  posicoesEncontradas.reverse().forEach((element, index, array) => {
    conteudoComHighlight = [
      conteudoComHighlight.slice(0, element.index),
      `<mark class="text-highlight" id="match-${index+1}">`,
      conteudoComHighlight.slice(element.index, element.lastIndex),
      '</mark>',
      conteudoComHighlight.slice(element.lastIndex)
    ].join('');
  });
  return conteudoComHighlight;
}

export default new stringHelper();
